module.exports = __webpack_public_path__ + "static/media/liaa-eraf-banner-lv.e5de05e6.svg";